export default "__VITE_ASSET__CZZVHTvn__"